import type { CollapseState } from '@/features/AskSyncly/types/constants';

export type GptResponse = {
  data: GptSummary[];
  state: GPT_RES_STATE;
};

export enum GPT_DOMAIN {
  GLOBAL_SEARCH = 2,
  GLOBAL_SEARCH_SUMMARY = 3,
  INSIGHT_EXPLORER = 4,
  SIGNAL = 5,
}

export enum GPT_REQUEST_TYPE {
  SUMMARY = 1,
  ACTION = 2,
  QUESTION = 3,
}

export enum GPT_RES_STATE {
  RECIEVED = 1,
  PROGRESSING = 2,
  COMPLETE = 3,
}

export type PromptTemplate = {
  text: string;
};

export type GptSocketBasePayload = {
  question: string;
  socket_id: string;
};

export type GptSocketSearchPayload = {
  alias: string;
  filterPayload?: StructuredFilter;
};

export type GptSocketSearchSummaryPayload = {
  alias: string;
  issue_index: number;
  sub_issue_index?: number;
};

export type GptSocketCommonPayload = {
  filterPayload?: StructuredFilter;
};

export type GptSocketBaseInfo = PartialBy<GptSocketInfo, 'question'>;

export type GptSocketInfo = {
  domain: GPT_DOMAIN;
  question: string;
  chart?: ChartGptPayload;
  search?: GptSocketSearchPayload;
  search_summary?: GptSocketSearchSummaryPayload;
  insight_explorer?: StructuredFilter;
  signal?: StructuredFilter;
  initialState?: CollapseState;
  initialPrompt?: string;
};

export type GptSummary = {
  title: string;
  desc: string;
  feedback_count: number;
  references: GptBlockReference[];
  examples: GptBlockReference[];
};

export type GptBlockReference = {
  feedback_id: string;
  block_id: string;
  quotation: string;
};

export type AskSynclyAISocketPayload = {
  task_id: string;
};
